import React from "react";
import COLORS from "../../constants/colors";

/**
 * 单词预览卡片组件
 * @param {Object} props - 组件属性
 * @param {Object} props.word - 单词数据对象（必传）
 * @param {string} props.word.word - 单词文本
 * @param {string} props.word.type - 单词词性
 * @param {string} props.word.translation - 单词释义
 * @param {Function} props.onDetail - 点击「查看详情」的回调函数
 * @param {string} [props.bgColor=COLORS.white] - 卡片背景色
 * @param {string} [props.borderRadius=16px] - 卡片圆角
 * @param {string} [props.marginBottom=0] - 卡片底部间距
 * @param {boolean} [props.ellipsis=true] - 释义是否单行截断
 * @param {string} [props.detailText=查看详细释义] - 详情按钮文本
 * @param {boolean} [props.loading=false] - 是否展示加载骨架屏
 * @returns {JSX.Element|null} 渲染后的卡片组件
 */
export default function WordPreviewCard({
  word,
  onDetail,
  bgColor = COLORS.white,
  borderRadius = "16px",
  marginBottom = "0",
  ellipsis = true,
  detailText = "查看详细释义",
  loading = false,
}) {
  // 加载态：展示骨架屏
  if (loading) {
    return (
      <div
        style={{
          background: bgColor,
          borderRadius,
          padding: "0.85rem 1rem",
          boxShadow: "0 8px 20px rgba(108,145,191,0.08)",
          border: `1px solid ${COLORS.line}`,
          marginTop: "0.5rem",
          marginBottom,
        }}
      >
        <div style={{ height: "1.3rem", width: "40%", background: "#F0F0F0", borderRadius: "4px" }}></div>
        <div style={{ height: "1.2rem", width: "70%", background: "#F0F0F0", borderRadius: "4px", marginTop: "0.5rem" }}></div>
        <div style={{ height: "1.1rem", width: "50%", background: "#F0F0F0", borderRadius: "4px", marginTop: "1rem" }}></div>
      </div>
    );
  }

  // 空数据：直接返回null
  if (!word) return null;

  // 正常渲染
  return (
    <div
      style={{
        background: bgColor,
        borderRadius,
        padding: "0.85rem 1rem",
        boxShadow: "0 8px 20px rgba(108,145,191,0.08)",
        border: `1px solid ${COLORS.line}`,
        marginTop: "0.5rem",
        marginBottom,
        boxSizing: "border-box", // 防止padding撑大卡片
      }}
    >
      {/* 单词文本 */}
      <div
        style={{
          fontWeight: 700,
          color: COLORS.text,
          fontSize: "1.02rem",
        }}
      >
        {word.word || ""}
      </div>

      {/* 词性+释义 */}
      <div
        style={{
          color: COLORS.subtext,
          fontSize: "0.92rem",
          marginTop: "0.2rem",
          whiteSpace: ellipsis ? "nowrap" : "normal",
          overflow: ellipsis ? "hidden" : "visible",
          textOverflow: ellipsis ? "ellipsis" : "clip",
        }}
      >
        {word.type || ""} {word.type && word.translation ? "·" : ""} {word.translation || ""}
      </div>

      {/* 查看详情按钮（有回调才渲染） */}
      {onDetail && (
        <div
          onClick={() => onDetail(word)} // 透传单词数据给回调
          style={{
            marginTop: "0.65rem",
            borderTop: "1px solid #F0F0F0",
            paddingTop: "0.55rem",
            color: COLORS.text || "#111",
            opacity: 0.75,
            cursor: "pointer",
            fontSize: "0.88rem",
            transition: "all 0.2s ease", // 过渡动画
            ":hover": {
              opacity: 1,
              color: COLORS.primary || "#4096ff", // 优先用项目主色，兜底蓝色
            },
            ":active": {
              opacity: 0.9,
              transform: "scale(0.98)", // 点击反馈
            },
            userSelect: "none", // 禁止文本选中
          }}
        >
          {detailText}
        </div>
      )}
    </div>
  );
}